import { InjectionToken } from '@angular/core';
import { IConfirmDialogService } from '../../dialogs/confirm/_interfaces/confirm-dialog-service.interface';

export const ConfirmDialogServiceInjectionToken = new InjectionToken<
  IConfirmDialogService
>('ConfirmDialogService');
